import { useCallback, useEffect, useRef, useState } from 'react';

export const useMenuDropdown = ({
  isMenuOpenInit = false,
  onMenuItemClick,
}: {
  isMenuOpenInit?: boolean;
  onMenuItemClick?: () => void;
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(isMenuOpenInit);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleToggleDropdown = useCallback((): void => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const handleAction = (action: () => void) => () => {
    onMenuItemClick?.();
    action();
    handleClose();
  };

  const handleEvent = useCallback(
    (event: Event) => {
      if (
        event.type === 'mouseup' &&
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        handleClose();
      } else if (event.type === 'keydown' && (event as KeyboardEvent).key === 'Escape') {
        handleClose();
      }
    },
    [handleClose]
  );

  const addEventListeners = useCallback(() => {
    document.addEventListener('mouseup', handleEvent);
    document.addEventListener('keydown', handleEvent);
    document.addEventListener('scroll', handleClose);
    menuRef?.current?.addEventListener('mouseleave', handleClose);
  }, []);

  const removeEventListeners = useCallback(() => {
    document.removeEventListener('mouseup', handleEvent);
    document.removeEventListener('keydown', handleEvent);
    document.removeEventListener('scroll', handleClose);
    menuRef?.current?.removeEventListener('mouseleave', handleClose);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      addEventListeners();
    } else {
      removeEventListeners();
    }

    return () => {
      removeEventListeners();
    };
  }, [isMenuOpen, handleEvent]);

  return {
    menuRef,
    handleToggleDropdown,
    onClose: handleClose,
    handleAction,
    setIsMenuOpen,
    isMenuOpen,
  };
};
// export const useMenuDropdown = ({
//                                   isMenuOpenInit,
//                                   onMenuItemClick,
//                                 }: {
//   isMenuOpenInit?: false;
//   onMenuItemClick?: () => void;
// }) => {
